import { fetchQuery } from 'react-relay'
import { type IEnvironment } from 'relay-runtime'

import SparkBalancePillQueryNode from '@/__generated__/SparkBalancePillQuery.graphql'

/**
 * Force-refetches currentUser { sparkBalance } network-only. Relay normalizes by
 * id, so updating the currentUser record repaints the header pill and every
 * screen fragment reading sparkBalance. Call after a purchase reconciles.
 */
export const refreshSparkBalance = async (environment: IEnvironment): Promise<void> => {
  await fetchQuery(environment, SparkBalancePillQueryNode, {}, { fetchPolicy: 'network-only' }).toPromise()
}
